// Kids mode celebration: a small burst of confetti squares, dots and stars that flies out of its parent's centre once
// when it mounts (for example around the star of a correct answer). Decorative only (aria-hidden, no text); the
// pieces, colours and paths live in globals.css (.kid-burst) and the burst is hidden under prefers-reduced-motion.
// The parent needs `position: relative`.

import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

const PIECES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

export const KidsBurst: FC<{ className?: string }> = ({ className }): ReactNode => (
    <span aria-hidden='true' className={cn('kid-burst', className)}>
        {PIECES.map(piece => <span key={piece} />)}
    </span>
)

export default KidsBurst
